import { maxBy } from 'lodash';
import { TestResults } from "../types";

export const getBestEdge = (results: TestResults[]) =>
    maxBy(results, (result) => result.results.preflight?.stats?.mos?.average);